(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-megamenu"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('encabezado-mega')) return;

    class EncabezadoMega extends HTMLElement {
      connectedCallback() {
        if (this.iniciado) return;
        this.iniciado = true;

        this.barra = this.querySelector('.encabezado-mega__barra');
        this.botonMenu = this.querySelector('.encabezado-mega__boton-menu');
        this.celdaIzquierda = this.querySelector('.encabezado-mega__izquierda');
        this.celdaDerecha = this.querySelector('.encabezado-mega__derecha');
        this.iconos = this.querySelector('.encabezado-mega__iconos');
        this.listaIzquierda = this.querySelector('.encabezado-mega__pestanas--izquierda');
        this.listaDerecha = this.querySelector('.encabezado-mega__pestanas--derecha');
        this.elementosPestana = this.listaIzquierda ? Array.from(this.listaIzquierda.children) : [];
        this.pestanas = Array.from(this.querySelectorAll('.encabezado-mega__pestana'));
        this.paneles = Array.from(this.querySelectorAll('.encabezado-mega__panel'));
        this.mediaDesktop = window.matchMedia('(min-width: 990px)');
        this.mediaSinHover = window.matchMedia('(hover: none)');
        this.indiceActivo = -1;
        this.temporizadorCierre = null;
        this.cuadroReorganizacion = null;
        this.ignorarFoco = false;

        this.pestanas.forEach((pestana) => {
          const indice = Number(pestana.dataset.indice);
          const tieneMega = pestana.dataset.mega === 'true';

          pestana.addEventListener('mouseenter', () => {
            if (!this.esDesktop() || this.mediaSinHover.matches) return;
            this.cancelarCierre();
            this.abrir(tieneMega ? indice : -1);
          });

          pestana.addEventListener('focus', () => {
            if (!this.esDesktop() || this.ignorarFoco) return;
            this.abrir(tieneMega ? indice : -1);
          });

          pestana.addEventListener('click', (evento) => {
            if (!tieneMega) return;
            const sinEnlace = pestana.getAttribute('href') === '#';

            if (!this.esDesktop()) {
              evento.preventDefault();
              this.abrir(indice);
              return;
            }

            if (sinEnlace) {
              evento.preventDefault();
              this.abrir(this.indiceActivo === indice ? -1 : indice);
              return;
            }

            if (this.mediaSinHover.matches && this.indiceActivo !== indice) {
              evento.preventDefault();
              this.abrir(indice);
            }
          });
        });

        this.addEventListener('mouseleave', () => {
          if (this.esDesktop() && !this.mediaSinHover.matches) this.programarCierre();
        });

        this.addEventListener('mouseenter', () => this.cancelarCierre());

        this.addEventListener('focusout', (evento) => {
          if (this.esDesktop() && !this.contains(evento.relatedTarget)) this.abrir(-1);
        });

        this.botonMenu?.addEventListener('click', () => {
          if (this.classList.contains('encabezado-mega--cajon-abierto')) {
            this.cerrarCajon();
          } else {
            this.abrirCajon();
          }
        });

        this.alPulsarTecla = (evento) => {
          if (evento.key !== 'Escape') return;

          if (this.classList.contains('encabezado-mega--cajon-abierto')) {
            this.cerrarCajon();
            this.botonMenu?.focus();
            return;
          }

          if (this.indiceActivo !== -1) {
            const pestana = this.pestanas.find((elemento) => Number(elemento.dataset.indice) === this.indiceActivo);
            this.abrir(-1);
            this.ignorarFoco = true;
            pestana?.focus();
            this.ignorarFoco = false;
          }
        };

        this.alClicFuera = (evento) => {
          if (this.esDesktop() && !this.contains(evento.target)) this.abrir(-1);
        };

        this.alCambiarMedia = () => {
          this.cerrarCajon();
          this.abrir(-1);
          this.programarReorganizacion();
        };

        this.programarReorganizacion = () => {
          if (this.cuadroReorganizacion) window.cancelAnimationFrame(this.cuadroReorganizacion);
          this.cuadroReorganizacion = window.requestAnimationFrame(() => {
            this.cuadroReorganizacion = null;
            this.reorganizar();
          });
        };

        document.addEventListener('keydown', this.alPulsarTecla);
        document.addEventListener('click', this.alClicFuera);
        this.mediaDesktop.addEventListener('change', this.alCambiarMedia);

        if ('ResizeObserver' in window && this.barra) {
          this.observador = new ResizeObserver(this.programarReorganizacion);
          this.observador.observe(this.barra);
        } else {
          window.addEventListener('resize', this.programarReorganizacion);
        }

        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(this.programarReorganizacion);
        }

        this.querySelectorAll('img').forEach((imagen) => {
          if (!imagen.complete) imagen.addEventListener('load', this.programarReorganizacion, { once: true });
        });

        this.addEventListener('shopify:block:select', (evento) => {
          const elemento = evento.target.closest('[data-indice]');
          if (!elemento) return;
          if (!this.esDesktop()) this.abrirCajon();
          this.abrir(Number(elemento.dataset.indice));
        });

        this.addEventListener('shopify:block:deselect', () => {
          if (this.esDesktop()) this.abrir(-1);
        });

        this.reorganizar();
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.alPulsarTecla);
        document.removeEventListener('click', this.alClicFuera);
        window.removeEventListener('resize', this.programarReorganizacion);
        this.mediaDesktop?.removeEventListener('change', this.alCambiarMedia);
        this.observador?.disconnect();
        document.documentElement.classList.remove('encabezado-mega-bloqueado');
        this.cancelarCierre();
        this.iniciado = false;
      }

      esDesktop() {
        return this.mediaDesktop.matches;
      }

      reorganizar() {
        this.classList.remove('encabezado-mega--compacto');
        this.distribuirPestanas();

        if (this.esDesktop() && this.hayDesbordeDerecha()) {
          this.classList.add('encabezado-mega--compacto');
          this.distribuirPestanas();
        }
      }

      distribuirPestanas() {
        if (!this.listaIzquierda || !this.listaDerecha) return;

        this.elementosPestana.forEach((elemento) => this.listaIzquierda.appendChild(elemento));

        if (!this.esDesktop()) {
          this.classList.remove('encabezado-mega--con-derecha');
          return;
        }

        const disponible = this.celdaIzquierda.clientWidth - 16;
        let acumulado = 0;
        let corte = this.elementosPestana.length;

        for (let i = 0; i < this.elementosPestana.length; i += 1) {
          acumulado += this.elementosPestana[i].offsetWidth;
          if (acumulado > disponible) {
            corte = i;
            break;
          }
        }

        this.elementosPestana.slice(corte).forEach((elemento) => this.listaDerecha.appendChild(elemento));
        this.classList.toggle('encabezado-mega--con-derecha', corte < this.elementosPestana.length);
      }

      hayDesbordeDerecha() {
        if (!this.listaDerecha || !this.celdaDerecha) return false;
        const necesario = this.listaDerecha.scrollWidth + (this.iconos ? this.iconos.offsetWidth : 0) + 16;
        return necesario > this.celdaDerecha.clientWidth;
      }

      programarCierre() {
        this.cancelarCierre();
        this.temporizadorCierre = window.setTimeout(() => this.abrir(-1), 180);
      }

      cancelarCierre() {
        if (this.temporizadorCierre) {
          window.clearTimeout(this.temporizadorCierre);
          this.temporizadorCierre = null;
        }
      }

      abrir(indice) {
        this.indiceActivo = indice;

        this.pestanas.forEach((pestana) => {
          const activa = Number(pestana.dataset.indice) === indice;
          pestana.classList.toggle('encabezado-mega__pestana--activa', activa);
          if (pestana.dataset.mega === 'true') {
            pestana.setAttribute('aria-expanded', activa ? 'true' : 'false');
          }
        });

        this.paneles.forEach((panel) => {
          panel.classList.toggle('encabezado-mega__panel--abierto', Number(panel.dataset.indice) === indice);
        });
      }

      abrirCajon() {
        const limites = this.barra.getBoundingClientRect();
        this.style.setProperty('--em-tope', `${Math.max(limites.bottom, 0)}px`);
        this.classList.add('encabezado-mega--cajon-abierto');
        this.botonMenu?.setAttribute('aria-expanded', 'true');
        this.botonMenu?.setAttribute('aria-label', 'Cerrar menú');
        document.documentElement.classList.add('encabezado-mega-bloqueado');

        const hayPanelActivo = this.paneles.some((panel) => Number(panel.dataset.indice) === this.indiceActivo);
        if (!hayPanelActivo && this.paneles.length > 0) {
          this.abrir(Number(this.paneles[0].dataset.indice));
        }
      }

      cerrarCajon() {
        this.classList.remove('encabezado-mega--cajon-abierto');
        this.botonMenu?.setAttribute('aria-expanded', 'false');
        this.botonMenu?.setAttribute('aria-label', 'Abrir menú');
        document.documentElement.classList.remove('encabezado-mega-bloqueado');
      }
    }

    customElements.define('encabezado-mega', EncabezadoMega);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-rotativo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('hero-rotativo-carrusel')) return;

    class HeroRotativoCarrusel extends HTMLElement {
      connectedCallback() {
        if (this.iniciado) return;
        this.iniciado = true;

        this.pista = this.querySelector('.hero-rotativo__pista');
        this.diapositivas = Array.from(this.querySelectorAll('.hero-rotativo__diapositiva'));
        this.puntos = Array.from(this.querySelectorAll('.hero-rotativo__punto'));
        this.botonAnterior = this.querySelector('.hero-rotativo__flecha--anterior');
        this.botonSiguiente = this.querySelector('.hero-rotativo__flecha--siguiente');
        this.total = this.diapositivas.length;
        this.indice = 0;
        this.esDeslizar = this.classList.contains('hero-rotativo--deslizar');
        this.autoplay = this.dataset.autoplay === 'true';
        this.velocidad = parseInt(this.dataset.velocidad, 10) || 5000;
        this.pausaHover = this.dataset.pausaHover === 'true';
        this.pausado = false;
        this.temporizador = null;
        this.inicioX = null;

        if (this.total < 2) return;

        this.botonAnterior?.addEventListener('click', () => this.navegar(this.indice - 1));
        this.botonSiguiente?.addEventListener('click', () => this.navegar(this.indice + 1));
        this.puntos.forEach((punto, i) => {
          punto.addEventListener('click', () => this.navegar(i));
        });

        this.addEventListener('keydown', (evento) => {
          if (evento.key === 'ArrowLeft') this.navegar(this.indice - 1);
          if (evento.key === 'ArrowRight') this.navegar(this.indice + 1);
        });

        if (this.pausaHover) {
          this.addEventListener('mouseenter', () => { this.pausado = true; });
          this.addEventListener('mouseleave', () => { this.pausado = false; });
        }

        this.addEventListener('focusin', () => { this.pausado = true; });
        this.addEventListener('focusout', (evento) => {
          if (!this.contains(evento.relatedTarget)) this.pausado = false;
        });

        const visor = this.querySelector('.hero-rotativo__visor');
        visor?.addEventListener('pointerdown', (evento) => {
          this.inicioX = evento.clientX;
        });
        visor?.addEventListener('pointerup', (evento) => {
          if (this.inicioX === null) return;
          const diferencia = evento.clientX - this.inicioX;
          this.inicioX = null;
          if (Math.abs(diferencia) < 50) return;
          this.navegar(diferencia < 0 ? this.indice + 1 : this.indice - 1);
        });
        visor?.addEventListener('pointercancel', () => { this.inicioX = null; });

        this.addEventListener('shopify:block:select', (evento) => {
          const i = this.diapositivas.indexOf(evento.target);
          if (i === -1) return;
          this.pausado = true;
          this.ir(i);
        });
        this.addEventListener('shopify:block:deselect', () => {
          this.pausado = false;
        });

        this.ir(0);
        this.iniciar();
      }

      disconnectedCallback() {
        this.detener();
        this.iniciado = false;
      }

      ir(nuevoIndice) {
        this.indice = (nuevoIndice + this.total) % this.total;

        this.diapositivas.forEach((diapositiva, i) => {
          const activa = i === this.indice;
          diapositiva.classList.toggle('hero-rotativo__diapositiva--activa', activa);
          diapositiva.setAttribute('aria-hidden', activa ? 'false' : 'true');
          if (activa) {
            diapositiva.removeAttribute('inert');
          } else {
            diapositiva.setAttribute('inert', '');
          }
        });

        this.puntos.forEach((punto, i) => {
          const activo = i === this.indice;
          punto.classList.toggle('hero-rotativo__punto--activo', activo);
          if (activo) {
            punto.setAttribute('aria-current', 'true');
          } else {
            punto.removeAttribute('aria-current');
          }
        });

        if (this.esDeslizar && this.pista) {
          this.pista.style.transform = `translateX(-${this.indice * 100}%)`;
        }
      }

      navegar(nuevoIndice) {
        this.ir(nuevoIndice);
        this.iniciar();
      }

      iniciar() {
        this.detener();
        if (!this.autoplay || this.total < 2) return;
        this.temporizador = window.setInterval(() => {
          if (!this.pausado && !document.hidden) this.ir(this.indice + 1);
        }, this.velocidad);
      }

      detener() {
        if (this.temporizador) {
          window.clearInterval(this.temporizador);
          this.temporizador = null;
        }
      }
    }

    customElements.define('hero-rotativo-carrusel', HeroRotativoCarrusel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pestanas-productos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('pestanas-productos-seccion')) return;

    class PestanasProductosSeccion extends HTMLElement {
      connectedCallback() {
        if (this.iniciado) return;
        this.iniciado = true;
        this.cuadroAjuste = null;

        this.pestanas = Array.from(this.querySelectorAll('.pestanas-productos__pestana'));
        this.paneles = Array.from(this.querySelectorAll('.pestanas-productos__panel'));
        this.listaPestanas = this.querySelector('.pestanas-productos__lista-pestanas');

        this.pestanas.forEach((pestana, i) => {
          pestana.addEventListener('click', () => this.activar(i));
        });

        this.listaPestanas?.addEventListener('keydown', (evento) => {
          const actual = this.pestanas.indexOf(document.activeElement);
          if (actual === -1) return;
          let siguiente = null;
          if (evento.key === 'ArrowRight') siguiente = (actual + 1) % this.pestanas.length;
          if (evento.key === 'ArrowLeft') siguiente = (actual - 1 + this.pestanas.length) % this.pestanas.length;
          if (evento.key === 'Home') siguiente = 0;
          if (evento.key === 'End') siguiente = this.pestanas.length - 1;
          if (siguiente === null) return;
          evento.preventDefault();
          this.activar(siguiente, true);
        });

        this.addEventListener('click', (evento) => {
          const muestra = evento.target.closest('.pestanas-productos__muestra');
          if (!muestra || !this.contains(muestra)) return;
          evento.preventDefault();
          this.seleccionarMuestra(muestra);
        });

        this.addEventListener('shopify:block:select', (evento) => {
          const i = this.pestanas.indexOf(evento.target);
          if (i !== -1) this.activar(i);
        });

        this.programarAjuste = () => {
          if (this.cuadroAjuste) window.cancelAnimationFrame(this.cuadroAjuste);
          this.cuadroAjuste = window.requestAnimationFrame(() => {
            this.cuadroAjuste = null;
            this.ajustarMuestras();
          });
        };

        if ('ResizeObserver' in window) {
          this.observador = new ResizeObserver(this.programarAjuste);
          this.observador.observe(this);
        } else {
          window.addEventListener('resize', this.programarAjuste);
        }

        this.ajustarMuestras();
      }

      disconnectedCallback() {
        this.observador?.disconnect();
        window.removeEventListener('resize', this.programarAjuste);
        this.iniciado = false;
      }

      activar(indice, enfocar = false) {
        this.pestanas.forEach((pestana, i) => {
          const activa = i === indice;
          pestana.classList.toggle('pestanas-productos__pestana--activa', activa);
          pestana.setAttribute('aria-selected', activa ? 'true' : 'false');
          pestana.setAttribute('tabindex', activa ? '0' : '-1');
          if (activa && enfocar) pestana.focus();
          if (activa) pestana.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        });

        this.paneles.forEach((panel, i) => {
          panel.hidden = i !== indice;
        });

        this.querySelectorAll('.pestanas-productos__ver-todo-cabecera .pestanas-productos__ver-todo').forEach((enlace) => {
          enlace.hidden = Number(enlace.dataset.indice) !== indice;
        });

        this.programarAjuste();
      }

      ajustarMuestras() {
        const maximo = Number(this.dataset.maximoMuestras) || 99;

        this.querySelectorAll('.pestanas-productos__panel:not([hidden]) .pestanas-productos__muestras').forEach((contenedor) => {
          const muestras = Array.from(contenedor.querySelectorAll('.pestanas-productos__muestra'));
          const extra = contenedor.querySelector('.pestanas-productos__extra');
          if (!muestras.length) return;

          muestras.forEach((muestra) => muestra.classList.remove('pestanas-productos__muestra--oculta'));
          if (extra) extra.hidden = true;

          const estilo = window.getComputedStyle(contenedor);
          const relleno = parseFloat(estilo.paddingLeft) + parseFloat(estilo.paddingRight);
          const disponible = contenedor.clientWidth - relleno;
          if (disponible <= 0) return;

          const espacio = parseFloat(estilo.columnGap) || 6;
          const anchoMuestra = muestras[0].offsetWidth + espacio;
          if (anchoMuestra <= espacio) return;
          const anchoExtra = 32;

          let caben = Math.floor((disponible + espacio) / anchoMuestra);
          if (caben < muestras.length || muestras.length > maximo) {
            caben = Math.floor((disponible + espacio - anchoExtra) / anchoMuestra);
          }
          caben = Math.max(1, Math.min(caben, maximo, muestras.length));

          const indiceActiva = muestras.findIndex((muestra) => muestra.classList.contains('pestanas-productos__muestra--activa'));

          muestras.forEach((muestra, i) => {
            let visible = i < caben;
            if (indiceActiva >= caben) {
              visible = i < caben - 1 || i === indiceActiva;
            }
            muestra.classList.toggle('pestanas-productos__muestra--oculta', !visible);
          });

          const ocultas = muestras.length - caben;
          if (extra) {
            extra.textContent = `+${ocultas}`;
            extra.hidden = ocultas <= 0;
          }
        });
      }

      seleccionarMuestra(muestra) {
        const tarjeta = muestra.closest('.pestanas-productos__tarjeta');
        if (!tarjeta) return;

        tarjeta.querySelectorAll('.pestanas-productos__muestra').forEach((elemento) => {
          const activa = elemento === muestra;
          elemento.classList.toggle('pestanas-productos__muestra--activa', activa);
          elemento.setAttribute('aria-pressed', activa ? 'true' : 'false');
        });

        const imagen = tarjeta.querySelector('.pestanas-productos__imagen');
        if (imagen && muestra.dataset.imagen) {
          if (muestra.dataset.srcset) imagen.srcset = muestra.dataset.srcset;
          imagen.src = muestra.dataset.imagen;
        }

        const subtitulo = tarjeta.querySelector('.pestanas-productos__subtitulo');
        if (subtitulo) subtitulo.textContent = muestra.dataset.subtitulo || '';

        const precio = tarjeta.querySelector('.pestanas-productos__precio');
        if (precio && muestra.dataset.precio) precio.textContent = muestra.dataset.precio;

        const comparado = tarjeta.querySelector('.pestanas-productos__precio-comparado');
        if (comparado) {
          comparado.textContent = muestra.dataset.precioComparado || '';
          comparado.hidden = !muestra.dataset.precioComparado;
        }

        if (muestra.dataset.url) {
          tarjeta.querySelectorAll('.pestanas-productos__enlace').forEach((enlace) => {
            enlace.href = muestra.dataset.url;
          });
        }
      }
    }

    customElements.define('pestanas-productos-seccion', PestanasProductosSeccion);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pie-pagina"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('pie-pagina-personalizado')) return;

    class PiePaginaPersonalizado extends HTMLElement {
      connectedCallback() {
        if (this.iniciado) return;
        this.iniciado = true;

        this.querySelectorAll('.pie-pagina__boton-columna').forEach((boton) => {
          boton.addEventListener('click', () => {
            const columna = boton.closest('.pie-pagina__columna');
            if (!columna) return;
            const abierta = columna.classList.toggle('pie-pagina__columna--abierta');
            boton.setAttribute('aria-expanded', abierta ? 'true' : 'false');
          });
        });

        this.addEventListener('shopify:block:select', (evento) => {
          const columna = evento.target.closest('.pie-pagina__columna');
          if (!columna) return;
          columna.classList.add('pie-pagina__columna--abierta');
          columna.querySelector('.pie-pagina__boton-columna')?.setAttribute('aria-expanded', 'true');
        });
      }
    }

    customElements.define('pie-pagina-personalizado', PiePaginaPersonalizado);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["producto-principal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('producto-principal')) return;

    class ProductoPrincipal extends HTMLElement {
      connectedCallback() {
        if (this.iniciado) return;
        this.iniciado = true;

        const nodoDatos = this.querySelector('.producto-principal__datos');
        if (!nodoDatos) return;

        try {
          this.datos = JSON.parse(nodoDatos.textContent);
        } catch (error) {
          this.datos = { indiceColor: -1, valoresColor: [], variantes: [] };
        }

        this.variantes = this.datos.variantes || [];
        this.formulario = this.querySelector('.producto-principal__formulario');
        this.inputVariante = this.querySelector('.producto-principal__id-variante');
        this.botones = Array.from(this.querySelectorAll('.producto-principal__boton'));
        this.error = this.querySelector('.producto-principal__error');
        this.aviso = this.querySelector('.producto-principal__aviso');
        this.pista = this.querySelector('.producto-principal__pista');
        this.diapositivas = Array.from(this.querySelectorAll('.producto-principal__diapositiva'));
        this.miniaturas = Array.from(this.querySelectorAll('.producto-principal__miniatura'));
        this.contenedorMiniaturas = this.querySelector('.producto-principal__miniaturas');
        this.flechaAnterior = this.querySelector('.producto-principal__miniaturas-flecha--anterior');
        this.flechaSiguiente = this.querySelector('.producto-principal__miniaturas-flecha--siguiente');
        this.puntos = this.querySelector('.producto-principal__puntos');
        this.barraFija = this.querySelector('.producto-principal__barra-fija');

        const idInicial = this.inputVariante ? this.inputVariante.value : '';
        const varianteInicial = this.variantes.find((variante) => String(variante.id) === idInicial) || this.variantes[0];
        this.seleccion = varianteInicial ? [...varianteInicial.opciones] : [];

        this.iniciarSelectores();
        this.iniciarGaleria();
        this.iniciarFormulario();
        this.iniciarUpsell();
        this.iniciarEntrega();
        this.iniciarBarraFija();

        if (varianteInicial) this.aplicarVariante(varianteInicial, false);
      }

      disconnectedCallback() {
        this.observadorBarra?.disconnect();
        window.removeEventListener('resize', this.alRedimensionar);
        document.documentElement.classList.remove('producto-principal-con-barra');
        window.clearTimeout(this.temporizadorAviso);
        this.iniciado = false;
      }

      iniciarSelectores() {
        this.querySelectorAll('.producto-principal__valor').forEach((boton) => {
          boton.addEventListener('click', () => {
            const indice = Number(boton.dataset.indiceOpcion);
            const valor = boton.dataset.valor;
            this.seleccion[indice] = valor;

            let variante = this.buscarVariante(this.seleccion);
            if (!variante) {
              variante = this.variantes.find((item) => item.opciones[indice] === valor && item.disponible)
                || this.variantes.find((item) => item.opciones[indice] === valor);
              if (variante) this.seleccion = [...variante.opciones];
            }

            if (variante) this.aplicarVariante(variante, true);
          });
        });
      }

      buscarVariante(opciones) {
        return this.variantes.find((variante) => variante.opciones.every((valor, i) => valor === opciones[i]));
      }

      aplicarVariante(variante, desdeUsuario) {
        this.varianteActual = variante;
        if (this.inputVariante) this.inputVariante.value = variante.id;

        this.querySelectorAll('.producto-principal__opcion').forEach((opcion) => {
          const indice = Number(opcion.dataset.indiceOpcion);
          const etiqueta = opcion.querySelector('.producto-principal__opcion-valor');
          if (etiqueta) etiqueta.textContent = this.seleccion[indice] || '';

          opcion.querySelectorAll('.producto-principal__valor').forEach((boton) => {
            const activo = boton.dataset.valor === this.seleccion[indice];
            boton.classList.toggle('producto-principal__valor--activo', activo);
            boton.setAttribute('aria-pressed', activo ? 'true' : 'false');

            const prueba = [...this.seleccion];
            prueba[indice] = boton.dataset.valor;
            const posible = this.variantes.some((item) => item.disponible && item.opciones.every((valor, i) => valor === prueba[i]));
            boton.classList.toggle('producto-principal__valor--agotado', !posible);
          });
        });

        this.querySelectorAll('[data-precio]').forEach((elemento) => {
          elemento.textContent = variante.precio;
        });

        this.querySelectorAll('.producto-principal__precio-comparado').forEach((elemento) => {
          elemento.textContent = variante.precioComparado || '';
          elemento.hidden = !variante.precioComparado;
        });

        this.botones.forEach((boton) => {
          boton.disabled = !variante.disponible;
          const texto = boton.querySelector('.producto-principal__boton-texto');
          if (texto) texto.textContent = variante.disponible ? this.dataset.textoBoton : this.dataset.textoAgotado;
        });

        this.filtrarGaleria();
        if (variante.medio) this.irAMedio(variante.medio, desdeUsuario);

        const enEditor = window.Shopify && window.Shopify.designMode;
        if (desdeUsuario && !enEditor) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variante.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      iniciarGaleria() {
        if (!this.pista) return;

        this.miniaturas.forEach((miniatura) => {
          miniatura.addEventListener('click', () => this.irAMedio(miniatura.dataset.medio, true));
        });

        this.pista.addEventListener('scroll', () => {
          if (this.cuadroScroll) return;
          this.cuadroScroll = window.requestAnimationFrame(() => {
            this.cuadroScroll = null;
            this.actualizarIndicadores();
          });
        }, { passive: true });

        this.flechaAnterior?.addEventListener('click', () => {
          this.contenedorMiniaturas.scrollBy({ left: -this.contenedorMiniaturas.clientWidth * 0.8, behavior: 'smooth' });
        });

        this.flechaSiguiente?.addEventListener('click', () => {
          this.contenedorMiniaturas.scrollBy({ left: this.contenedorMiniaturas.clientWidth * 0.8, behavior: 'smooth' });
        });

        this.contenedorMiniaturas?.addEventListener('scroll', () => this.actualizarFlechasMiniaturas(), { passive: true });

        this.alRedimensionar = () => {
          this.actualizarIndicadores();
          this.actualizarFlechasMiniaturas();
        };
        window.addEventListener('resize', this.alRedimensionar);
      }

      diapositivasVisibles() {
        return this.diapositivas.filter((diapositiva) => !diapositiva.classList.contains('producto-principal__diapositiva--oculta'));
      }

      filtrarGaleria() {
        if (!this.pista) return;

        const valoresColor = (this.datos.valoresColor || []).map((valor) => String(valor).toLowerCase().trim());
        const indiceColor = this.datos.indiceColor;
        const colorActual = indiceColor >= 0 && this.seleccion[indiceColor] ? this.seleccion[indiceColor].toLowerCase().trim() : '';
        const hayCoincidencias = colorActual && this.diapositivas.some((diapositiva) => diapositiva.dataset.alt === colorActual);

        const esVisible = (alt) => {
          if (!hayCoincidencias) return true;
          if (!valoresColor.includes(alt)) return true;
          return alt === colorActual;
        };

        this.diapositivas.forEach((diapositiva) => {
          diapositiva.classList.toggle('producto-principal__diapositiva--oculta', !esVisible(diapositiva.dataset.alt || ''));
        });

        this.miniaturas.forEach((miniatura) => {
          miniatura.classList.toggle('producto-principal__miniatura--oculta', !esVisible(miniatura.dataset.alt || ''));
        });

        this.pista.scrollLeft = 0;
        this.construirPuntos();
        this.actualizarIndicadores();
        this.actualizarFlechasMiniaturas();
      }

      construirPuntos() {
        if (!this.puntos) return;
        this.puntos.innerHTML = '';
        const visibles = this.diapositivasVisibles();
        if (visibles.length < 2) return;

        visibles.forEach((diapositiva, i) => {
          const punto = document.createElement('button');
          punto.type = 'button';
          punto.className = 'producto-principal__punto';
          punto.setAttribute('aria-label', `Ver imagen ${i + 1}`);
          punto.addEventListener('click', () => this.irADiapositiva(diapositiva, true));
          this.puntos.appendChild(punto);
        });
      }

      irAMedio(idMedio, suave) {
        const diapositiva = this.diapositivasVisibles().find((item) => item.dataset.medio === String(idMedio));
        if (diapositiva) this.irADiapositiva(diapositiva, suave);
      }

      irADiapositiva(diapositiva, suave) {
        if (!this.pista) return;
        this.pista.scrollTo({ left: diapositiva.offsetLeft, behavior: suave ? 'smooth' : 'auto' });
        if (!suave) this.actualizarIndicadores();
      }

      actualizarIndicadores() {
        if (!this.pista) return;
        const visibles = this.diapositivasVisibles();
        const ancho = this.pista.clientWidth || 1;
        const indice = Math.min(Math.round(this.pista.scrollLeft / ancho), visibles.length - 1);
        const activa = visibles[indice];

        if (this.puntos) {
          Array.from(this.puntos.children).forEach((punto, i) => {
            punto.classList.toggle('producto-principal__punto--activo', i === indice);
          });
        }

        if (!activa) return;

        this.miniaturas.forEach((miniatura) => {
          const esActiva = miniatura.dataset.medio === activa.dataset.medio;
          miniatura.classList.toggle('producto-principal__miniatura--activa', esActiva);

          if (esActiva && this.contenedorMiniaturas) {
            const contenedor = this.contenedorMiniaturas;
            const inicio = miniatura.offsetLeft;
            const fin = inicio + miniatura.offsetWidth;
            if (inicio < contenedor.scrollLeft || fin > contenedor.scrollLeft + contenedor.clientWidth) {
              contenedor.scrollTo({ left: Math.max(inicio - 8, 0), behavior: 'smooth' });
            }
          }
        });
      }

      actualizarFlechasMiniaturas() {
        const contenedor = this.contenedorMiniaturas;
        if (!contenedor) return;
        const maximo = contenedor.scrollWidth - contenedor.clientWidth;
        if (this.flechaAnterior) this.flechaAnterior.hidden = contenedor.scrollLeft <= 2;
        if (this.flechaSiguiente) this.flechaSiguiente.hidden = contenedor.scrollLeft >= maximo - 2;
      }

      iniciarFormulario() {
        if (!this.formulario) return;

        this.formulario.addEventListener('submit', async (evento) => {
          evento.preventDefault();
          if (this.enviando || !this.inputVariante) return;

          this.enviando = true;
          this.botones.forEach((boton) => boton.classList.add('producto-principal__boton--cargando'));
          this.mostrarError('');

          try {
            await this.agregarAlCarrito(Number(this.inputVariante.value), 1);

            if (this.dataset.despues === 'carrito') {
              window.location.href = this.dataset.urlCarrito;
              return;
            }

            await this.actualizarContador();
            this.mostrarAviso();
          } catch (error) {
            this.mostrarError(error.message);
          } finally {
            this.enviando = false;
            this.botones.forEach((boton) => boton.classList.remove('producto-principal__boton--cargando'));
          }
        });
      }

      async agregarAlCarrito(idVariante, cantidad) {
        const respuesta = await fetch(`${this.dataset.urlAgregar}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: idVariante, quantity: cantidad }] })
        });
        const resultado = await respuesta.json();
        if (!respuesta.ok) {
          throw new Error(resultado.description || resultado.message || 'No se pudo añadir al carrito');
        }
        return resultado;
      }

      async actualizarContador() {
        try {
          const respuesta = await fetch(`${this.dataset.urlCarrito}.js`, { headers: { Accept: 'application/json' } });
          const carrito = await respuesta.json();

          document.querySelectorAll('.encabezado-mega__icono--carrito').forEach((enlace) => {
            let burbuja = enlace.querySelector('.encabezado-mega__burbuja');
            if (carrito.item_count > 0) {
              if (!burbuja) {
                burbuja = document.createElement('span');
                burbuja.className = 'encabezado-mega__burbuja';
                burbuja.setAttribute('aria-hidden', 'true');
                enlace.appendChild(burbuja);
              }
              burbuja.textContent = carrito.item_count;
            } else if (burbuja) {
              burbuja.remove();
            }
            enlace.setAttribute('aria-label', `Carrito, ${carrito.item_count} productos`);
          });

          document.dispatchEvent(new CustomEvent('carrito:actualizado', { detail: carrito }));
        } catch (error) {
          return;
        }
      }

      mostrarError(mensaje) {
        if (!this.error) return;
        this.error.textContent = mensaje || '';
        this.error.hidden = !mensaje;
      }

      mostrarAviso() {
        if (!this.aviso) return;
        window.clearTimeout(this.temporizadorAviso);
        this.aviso.hidden = false;
        window.requestAnimationFrame(() => this.aviso.classList.add('producto-principal__aviso--visible'));
        this.temporizadorAviso = window.setTimeout(() => {
          this.aviso.classList.remove('producto-principal__aviso--visible');
          window.setTimeout(() => { this.aviso.hidden = true; }, 300);
        }, 4000);
      }

      async iniciarUpsell() {
        const contenedor = this.querySelector('.producto-principal__upsell');
        if (!contenedor || !this.dataset.urlRecomendaciones) return;

        const parametros = new URLSearchParams({
          product_id: this.dataset.producto,
          limit: this.dataset.limiteUpsell || '4',
          intent: 'complementary',
          section_id: this.dataset.seccion
        });

        try {
          const respuesta = await fetch(`${this.dataset.urlRecomendaciones}?${parametros.toString()}`);
          const html = await respuesta.text();
          const documento = new DOMParser().parseFromString(html, 'text/html');
          const resultado = documento.querySelector('.producto-principal__upsell-respuesta');
          if (!resultado || !resultado.children.length) return;

          const pista = contenedor.querySelector('.producto-principal__upsell-pista');
          pista.innerHTML = resultado.innerHTML;
          contenedor.hidden = false;

          pista.querySelectorAll('.producto-principal__upsell-agregar').forEach((boton) => {
            boton.addEventListener('click', async () => {
              if (boton.dataset.cargando === 'true') return;
              boton.dataset.cargando = 'true';
              try {
                await this.agregarAlCarrito(Number(boton.dataset.variante), 1);
                boton.classList.add('producto-principal__upsell-agregar--agregado');
                await this.actualizarContador();
                this.mostrarAviso();
                window.setTimeout(() => boton.classList.remove('producto-principal__upsell-agregar--agregado'), 1800);
              } catch (error) {
                this.mostrarError(error.message);
              } finally {
                boton.dataset.cargando = 'false';
              }
            });
          });

          const progreso = contenedor.querySelector('.producto-principal__upsell-progreso');
          const barra = contenedor.querySelector('.producto-principal__upsell-progreso-barra');
          const actualizarProgreso = () => {
            const total = pista.scrollWidth || 1;
            const visible = pista.clientWidth;
            if (progreso) progreso.hidden = total <= visible + 2;
            if (barra) {
              barra.style.setProperty('width', `${(visible / total) * 100}%`, 'important');
              barra.style.setProperty('left', `${(pista.scrollLeft / total) * 100}%`, 'important');
            }
          };

          pista.addEventListener('scroll', actualizarProgreso, { passive: true });
          window.addEventListener('resize', actualizarProgreso);
          actualizarProgreso();
        } catch (error) {
          return;
        }
      }

      iniciarEntrega() {
        const caja = this.querySelector('.producto-principal__entrega');
        if (!caja) return;

        const ahora = this.fechaLima();
        const corte = Number(this.dataset.horaCorte || 0);
        const base = new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate());
        const extra = ahora.getHours() >= corte ? 1 : 0;
        const formato = new Intl.DateTimeFormat('es-PE', { weekday: 'long', day: 'numeric', month: 'long' });

        caja.querySelectorAll('.producto-principal__entrega-linea').forEach((linea) => {
          const minimo = Number(linea.dataset.minimo || 0) + extra;
          const maximo = Math.max(Number(linea.dataset.maximo || 0) + extra, minimo);
          const desde = this.sumarDiasHabiles(base, minimo);
          const hasta = this.sumarDiasHabiles(base, maximo);
          const plantilla = linea.dataset.plantilla || '';
          linea.textContent = plantilla
            .replace('[desde]', formato.format(desde))
            .replace('[hasta]', formato.format(hasta));
        });

        caja.hidden = false;
      }

      fechaLima() {
        const partes = new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/Lima',
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          hourCycle: 'h23'
        }).formatToParts(new Date());
        const valor = (tipo) => Number((partes.find((parte) => parte.type === tipo) || {}).value || 0);
        return new Date(valor('year'), valor('month') - 1, valor('day'), valor('hour'));
      }

      sumarDiasHabiles(fecha, dias) {
        const resultado = new Date(fecha);
        let sumados = 0;
        while (sumados < dias) {
          resultado.setDate(resultado.getDate() + 1);
          const diaSemana = resultado.getDay();
          if (diaSemana !== 0 && diaSemana !== 6) sumados += 1;
        }
        return resultado;
      }

      iniciarBarraFija() {
        if (!this.barraFija) return;
        document.documentElement.classList.add('producto-principal-con-barra');

        if (!this.formulario || !('IntersectionObserver' in window)) {
          this.barraFija.classList.add('producto-principal__barra-fija--visible');
          return;
        }

        this.observadorBarra = new IntersectionObserver(([entrada]) => {
          this.barraFija.classList.toggle('producto-principal__barra-fija--visible', !entrada.isIntersecting);
        });
        this.observadorBarra.observe(this.formulario);
      }
    }

    customElements.define('producto-principal', ProductoPrincipal);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["productos-relacionados"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('productos-relacionados')) return;

    class ProductosRelacionados extends HTMLElement {
      connectedCallback() {
        if (this.iniciado) return;
        this.iniciado = true;
        this.cuadroAjuste = null;

        this.addEventListener('click', (evento) => {
          const muestra = evento.target.closest('.productos-relacionados__muestra');
          if (!muestra || !this.contains(muestra)) return;
          evento.preventDefault();
          this.seleccionarMuestra(muestra);
        });

        this.programarAjuste = () => {
          if (this.cuadroAjuste) window.cancelAnimationFrame(this.cuadroAjuste);
          this.cuadroAjuste = window.requestAnimationFrame(() => {
            this.cuadroAjuste = null;
            this.ajustarMuestras();
          });
        };

        if ('ResizeObserver' in window) {
          this.observador = new ResizeObserver(this.programarAjuste);
          this.observador.observe(this);
        } else {
          window.addEventListener('resize', this.programarAjuste);
        }

        this.ajustarMuestras();
        this.cargarRecomendaciones();
      }

      disconnectedCallback() {
        this.observador?.disconnect();
        window.removeEventListener('resize', this.programarAjuste);
        this.iniciado = false;
      }

      async cargarRecomendaciones() {
        const { producto, seccion, url, limite } = this.dataset;
        if (!producto || !url) {
          this.actualizarVisibilidad();
          return;
        }

        try {
          const parametros = new URLSearchParams({
            product_id: producto,
            limit: limite || '4',
            section_id: seccion,
            intent: 'related'
          });
          const respuesta = await fetch(`${url}?${parametros.toString()}`);
          if (!respuesta.ok) throw new Error('Sin recomendaciones');

          const html = await respuesta.text();
          const documento = new DOMParser().parseFromString(html, 'text/html');
          const grillaNueva = documento.querySelector('.productos-relacionados__grilla');
          const grillaActual = this.querySelector('.productos-relacionados__grilla');

          if (grillaNueva && grillaActual && grillaNueva.children.length > 0) {
            grillaActual.innerHTML = grillaNueva.innerHTML;
          }
        } catch (error) {
          this.actualizarVisibilidad();
          this.programarAjuste();
          return;
        }

        this.actualizarVisibilidad();
        this.programarAjuste();
      }

      actualizarVisibilidad() {
        const grilla = this.querySelector('.productos-relacionados__grilla');
        const vacia = !grilla || grilla.children.length === 0;
        this.classList.toggle('productos-relacionados--vacio', vacia);
      }

      ajustarMuestras() {
        const maximo = Number(this.dataset.maximoMuestras) || 99;

        this.querySelectorAll('.productos-relacionados__muestras').forEach((contenedor) => {
          const muestras = Array.from(contenedor.querySelectorAll('.productos-relacionados__muestra'));
          const extra = contenedor.querySelector('.productos-relacionados__extra');
          if (!muestras.length) return;

          muestras.forEach((muestra) => muestra.classList.remove('productos-relacionados__muestra--oculta'));
          if (extra) extra.hidden = true;

          const estilo = window.getComputedStyle(contenedor);
          const relleno = parseFloat(estilo.paddingLeft) + parseFloat(estilo.paddingRight);
          const disponible = contenedor.clientWidth - relleno;
          if (disponible <= 0) return;

          const espacio = parseFloat(estilo.columnGap) || 6;
          const anchoMuestra = muestras[0].offsetWidth + espacio;
          if (anchoMuestra <= espacio) return;
          const anchoExtra = 32;

          let caben = Math.floor((disponible + espacio) / anchoMuestra);
          if (caben < muestras.length || muestras.length > maximo) {
            caben = Math.floor((disponible + espacio - anchoExtra) / anchoMuestra);
          }
          caben = Math.max(1, Math.min(caben, maximo, muestras.length));

          const indiceActiva = muestras.findIndex((muestra) => muestra.classList.contains('productos-relacionados__muestra--activa'));

          muestras.forEach((muestra, i) => {
            let visible = i < caben;
            if (indiceActiva >= caben) {
              visible = i < caben - 1 || i === indiceActiva;
            }
            muestra.classList.toggle('productos-relacionados__muestra--oculta', !visible);
          });

          const ocultas = muestras.length - caben;
          if (extra) {
            extra.textContent = `+${ocultas}`;
            extra.hidden = ocultas <= 0;
          }
        });
      }

      seleccionarMuestra(muestra) {
        const tarjeta = muestra.closest('.productos-relacionados__tarjeta');
        if (!tarjeta) return;

        tarjeta.querySelectorAll('.productos-relacionados__muestra').forEach((elemento) => {
          const activa = elemento === muestra;
          elemento.classList.toggle('productos-relacionados__muestra--activa', activa);
          elemento.setAttribute('aria-pressed', activa ? 'true' : 'false');
        });

        const imagen = tarjeta.querySelector('.productos-relacionados__imagen');
        if (imagen && muestra.dataset.imagen) {
          if (muestra.dataset.srcset) imagen.srcset = muestra.dataset.srcset;
          imagen.src = muestra.dataset.imagen;
        }

        const subtitulo = tarjeta.querySelector('.productos-relacionados__subtitulo');
        if (subtitulo) subtitulo.textContent = muestra.dataset.subtitulo || '';

        const precio = tarjeta.querySelector('.productos-relacionados__precio');
        if (precio && muestra.dataset.precio) precio.textContent = muestra.dataset.precio;

        const comparado = tarjeta.querySelector('.productos-relacionados__precio-comparado');
        if (comparado) {
          comparado.textContent = muestra.dataset.precioComparado || '';
          comparado.hidden = !muestra.dataset.precioComparado;
        }

        const enlace = tarjeta.querySelector('.productos-relacionados__enlace');
        if (enlace && muestra.dataset.url) enlace.href = muestra.dataset.url;
      }
    }

    customElements.define('productos-relacionados', ProductosRelacionados);
  })();

  } catch(e) { console.error(e); }
})();
})();
